<template>
  <div>
    <div class="loading-page" id="loading-page">
      <div class="counter">
        <a class="navbar-brand" href="">
          <img class="img-responsive  myImages" src="../../../assets/images/Logo-01.png" width="180px" height="80px"/></a>
        <br><br><br>
        <h5 style="padding: 17px 24px; color:#141619 ">کمی صبر کنید. در حال راه اندازی آزمون هستیم</h5> <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadingFull",
  data() {
    return {
      counter: 0,
      number: 0,
      numbers_in: "",
      status: ""
    }
  },
  created() {
  },


}
</script>

<style scoped>

</style>